import { makeObservable } from "@faire/web/common/makeObservable";
import { singletonGetter } from "@faire/web/common/singletons/getter";
import { createStoreHook } from "@faire/web/ui/hooks/useStore";
import { action, computed, observable } from "mobx";

/**
 * @deprecated prefer to use `useAppSnackbarStore` or `withStores` instead
 */
export class AppSnackbarStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * @trackfunction
   */
  static get = singletonGetter(AppSnackbarStore);

  @observable
  private _productTitle: string | undefined;

  @observable
  private _brandName: string | undefined;

  @action
  setProductTitle = (title: string | undefined) => {
    this._productTitle = title;
  };

  @action
  setBrandName = (name: string | undefined) => {
    this._brandName = name;
  };

  @computed
  get brandName(): string | undefined {
    return this._brandName;
  }

  @computed
  get productTitle(): string | undefined {
    return this._productTitle;
  }
}

export const useAppSnackbarStore = createStoreHook(AppSnackbarStore);
